/* loaded by smart-asset */
export default require("./assets/red-pallet.i.svg")